import { Col, Row } from 'antd';
import { useCallback } from 'react';
import moment, { Moment } from 'jalali-moment';
import { MinusCircleOutlined } from '@ant-design/icons';
import { Flex } from '../../common';
import { useSelfContext } from '@/context';
import { ReserveInfoModalData } from '../../modals/ReserveInfoModal';
import { FaCheckCircle } from 'react-icons/fa';
import classNames from 'classnames';

export interface ReserveReportTableProps {
  reports?: ReportDayEntity[];
  mealTypes?: ReserveMealEntity[];
  onItemClick?: (data: ReserveInfoModalData) => any;
}

export function ReserveReportMobile({
  reports,
  mealTypes,
  onItemClick
}: ReserveReportTableProps) {

  const { showingDate } = useSelfContext();

  // TODO: Make this cleanr and use date-fns insteam of moment
  const startDate = showingDate
    ? moment.from(showingDate, 'en', 'YYYY-MM-DD').startOf('jWeek' as 'jw')
    : moment().locale('fa').startOf('jWeek' as 'jw');

  const dates: Moment[] = [];
  for (let i = 0; i < 7; i++) {
    dates[i] = startDate.clone().add(i, 'jDay');
  }

  const len = mealTypes?.length ?? 1;
  const colWidth = `${100 / (len)}%`;
  const colMinWidth = '60px';

  const renderReportStatus = useCallback((dateMoment: Moment, meal: ReserveMealEntity) => {
    const date = dateMoment.locale('en').format('YYYY-MM-DD');
    const filteredReports = reports.filter(r => r.date === date);
    for (const item of filteredReports) {
      const filteredMealTypes = (item.mealTypes ?? []).filter(m => (
        m.reserve != null ||
        m.teammateReserve != null
      ));
      for (const mealType of filteredMealTypes) {
        if (meal.id === mealType.mealTypeId) {
          const foods = filteredMealTypes.filter(x => x.mealTypeId === meal.id);
          const isAllConsumed = foods.filter(f => (
            f?.reserve?.consumed ||
            f?.teammateReserve?.consumed
          )).length === foods.length;
          return (
            <FaCheckCircle
              className={classNames('text-[1.25rem]', isAllConsumed ? 'text-accent' : 'text-primary')}
              onClick={() => onItemClick({ 
                meal, 
                report: item, 
                mealTypes: foods,
                startServeTime: foods[0]?.startServeTime || foods[0]?.teammateReserve?.startServeTime,
                endServeTime: foods[0]?.endServeTime || foods[0]?.teammateReserve?.endServeTime
              })}
            />
          );
        }
      }
    }
    return <MinusCircleOutlined className="text-[1.25rem] text-gray-400" />;
  }, [reports]);

  return (
    <Flex className="app-reserve-report-mobile h-full" align="flex-start" justify="center">
      <Row className="w-full h-full">
        <Col className="ps-4 py-4 h-full" span={7}>
          <Flex className="date-sidebar" direction="column" justify="center">
            <Flex className="date-text">{startDate.format('jYYYY/jMM/jDD')}</Flex>
            {dates.map((date, i) => (
              <Flex className="date-sidebar-item" key={i}>
                <span>{date.locale('fa').format('dddd')}</span>
              </Flex>
            ))}
            <Flex className="date-text">
              {startDate.clone().add(6, 'jDay').format('jYYYY/jMM/jDD')}
            </Flex>
          </Flex>
        </Col>
        <Col span={17} className="h-full w-full py-4 pe-4">
          <Flex className="meals-status" direction="column" align="flex-start" justify="center">

            <Flex className="status-item !bg-[#E5E5E5]" align="center">
              {(mealTypes ?? []).map((meal, j) => (
                <Flex
                  key={j}
                  className="status-col"
                  style={{ width: colWidth, minWidth: colMinWidth }}
                >
                  {meal.name}
                </Flex>
              ))}
            </Flex>

            {dates.map((date, i) => (
              <Flex key={i} className="status-item" align="center">
                {(mealTypes ?? []).map((meal, j) => (
                  <Flex
                    key={j}
                    className="status-col"
                    style={{ width: colWidth, minWidth: colMinWidth }}
                  >
                    {renderReportStatus(date, meal)}
                  </Flex>
                ))}
              </Flex>
            ))}
            <Flex className="status-item !bg-transparent" align="center"></Flex>
          </Flex>
        </Col>
      </Row>
    </Flex>
  );
}

export default ReserveReportMobile;
